(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('register-page', {
                parent: 'site',
                data: {
                    authorities: []
                },
                templateUrl: 'app/components/register-page/register-page.html',
                controller: 'RegisterPageController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('contact-us-privacy', {
                parent: 'site',
                cache:false,
                data: {
                    authorities: []
                },
                templateUrl: 'app/components/otp/contact.html',
                controller: 'ContactUsControllerPrivacy',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
